module.exports = __webpack_public_path__ + "img/engine-oil-wiper.ac868922.png";